import { render, staticRenderFns } from "./TransplantLicense.vue?vue&type=template&id=2041d9b4"
import script from "./TransplantLicense.vue?vue&type=script&lang=js"
export * from "./TransplantLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports